angular.module('core').filter('errorMessages', [
    function() {
        return function(error) {
          var text = '';
          if(_.isString(error.code)) {
              switch(error.code) {
                case "7000":
                  text = "New students are not yet ready to be displayed.";
                  break;
              }
            }
          return text;
        };
    }
]);
